// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"InformationIconPopover-7f3b473e774526c2","popoverTextWrapper":"InformationIconPopover-901a8da1e2376e8a"};